import { Routes } from '@angular/router';
import { DevicesComponent } from './devices.component';
import { DevicesService } from './devices.service';
import { DEVICE_CARD_CHILDREN } from './views/device-list/components/device-card/device-card.routes';
import { registeredEquipmentCardGuard } from '../../core/guards/registered-equipment-card.guard';

export const DEVICE_ID_PARAM = 'deviceId';

export const DEVICES_ROUTES: Routes = [
  {
    path: '',
    component: DevicesComponent,
    providers: [DevicesService],
    children: [
      {
        path: 'timetable/journal',
        loadComponent: () =>
          import(
            './views/timetable/schedule-journal/schedule-journal-page/schedule-journal-page.component'
          ).then((m) => m.ScheduleJournalPageComponent),
      },
      {
        path: 'timetable',
        loadComponent: () =>
          import('./views/timetable/timetable.component').then((m) => m.TimetableComponent),
        // Карточка аппарата открывается поверх расписаний и закрывается обратно к ним.
        children: [
          {
            path: `:${DEVICE_ID_PARAM}`,
            canActivate: [registeredEquipmentCardGuard],
            loadComponent: () =>
              import('./views/device-list/components/device-card/device-card.component').then(
                (m) => m.DeviceCardComponent,
              ),
            children: DEVICE_CARD_CHILDREN,
          },
        ],
      },
      {
        path: '',
        loadComponent: () =>
          import('./views/device-list/device-list.component').then((m) => m.DeviceListComponent),
        children: [
          {
            path: `:${DEVICE_ID_PARAM}`,
            loadComponent: () =>
              import('./views/device-list/components/device-card/device-card.component').then(
                (m) => m.DeviceCardComponent,
              ),
            children: DEVICE_CARD_CHILDREN,
          },
        ],
      },
    ],
  },
];
